module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0160.jpg?v=cf92879d";